<template>
  <tela-component title="Central de Pedidos - Insumos/Veterinária" rota="/selecionar-tipo-pedido/pedidos">
    <v-card flat rounded="lg">
      <v-card-title>Pedidos que precisam ser faturados</v-card-title>
      <v-card-text>
        <v-text-field label="Pesquisar" v-model="pesquisa"></v-text-field>
        <template v-if="isMobile()">
          <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
          <v-alert
            v-else-if="pedidosFiltrados().length == 0"
            dense
            type="info"
            text
            class="subtitle-1"
          >
            Nenhum pedido encontrado
          </v-alert>
          <v-expansion-panels accordion v-else>
            <v-expansion-panel
              v-for="item in pedidosFiltrados()"
              :key="item.id"
              class="mt-2"
            >
              <v-expansion-panel-header
                color="grey lighten-4"
                class="pb-0 pt-0 pl-1 pr-2"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="mt-1"
                      >{{ item.pessoa }} -
                      {{ item.desc_pessoa }}</v-list-item-title
                    >
                    <v-list-item-subtitle>
                      <p class="mt-1 mb-1">Filial: {{ item.filial }}</p>
                      <p class="mb-1">Pedido: {{ item.pedido }}</p>
                      <p class="mb-1">
                        Emissão: {{ formatarData(item.emissao) }}
                      </p>
                      <p class="mb-1">
                        Vencimento: {{ formatarData(item.vcto) }}
                      </p>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-2">
                <v-list>                  
                  <template v-for="(prod, i) in item.itens">                    
                    <v-list-item :key="prod.id" dense>
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ prod.descricao }} ({{ prod.grupo }} -
                          {{ prod.subgrupo }} -
                          {{ prod.item }})</v-list-item-title
                        >
                        <v-list-item-subtitle>
                          <p class="mt-1 mb-1">
                            Embalagem: {{ prod.embalagem }}
                          </p>
                          <p class="mb-1">
                            Unitário: {{ formatarMoeda(prod.unitario) }}
                          </p>
                          <p class="mb-1">Saldo: {{ prod.saldo }}</p>
                          <p class="mb-1">
                            Valor total:
                            {{ formatarMoeda(prod.saldo * prod.unitario) }}
                          </p>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="i" v-if="i + 1 < prod.length"></v-divider>
                  </template>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <template v-else>
          <v-data-table
            :loading="loading"
            :items="pedidosComSaldo"
            no-data-text="Não há pedidos em aberto"
            no-results-text="Nenhum pedido localizado com este filtro"
            :headers="headers"
            loading-text="Carregando pedidos..."
            :header-props="headerPropsTabela()"
            :search="pesquisa"
            item-key="id"
            show-expand
            single-expand
          >
            <template v-slot:[`item.emissao`]="{ item }">
              {{ formatarData(item.emissao) }}
            </template>
            <template v-slot:[`item.vcto`]="{ item }">
              {{ formatarData(item.vcto) }}
            </template>
            <template v-slot:[`item.desc_pessoa`]="{ item }">
              {{ item.pessoa }} - {{ item.desc_pessoa }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-card flat class="grey lighten-4 mt-3 mb-3" rounded="lg">
                  <v-card-subtitle>Itens do pedido</v-card-subtitle>
                  <v-card-text>
                    <v-data-table
                      dense
                      :items="item.itens"
                      :headers="headersItens"
                      hide-default-footer
                    >
                      <template v-slot:[`item.unitario`]="{ item }">
                        {{ formatarMoeda(item.unitario) }}
                      </template>
                      <template v-slot:[`item.vlrtotal`]="{ item }">
                        {{ formatarMoeda(item.unitario * item.saldo) }}
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </td>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import { formatMoeda } from "@/global";
export default {
  components: { TelaComponent },
  computed: mapState("insumos", ["pedidosComSaldo"]),
  data: () => ({
    pesquisa: "",
    loading: true,
    headers: [
      { text: "Filial", value: "filial" },
      { text: "Pedido", value: "pedido" },
      { text: "Emissão", value: "emissao" },
      { text: "Vencimento", value: "vcto" },
      { text: "Produtor", value: "desc_pessoa" },
    ],
    headersItens: [
      { text: "Gp", value: "grupo" },
      { text: "Sgp", value: "subgrupo" },
      { text: "Item", value: "item" },
      { text: "Produto", value: "descricao" },
      { text: "Embalagem", value: "embalagem" },
      { text: "Unitário", value: "unitario" },
      { text: "Saldo", value: "saldo" },
      { text: "Valor total", value: "vlrtotal" },
    ],
  }),
  methods: {
    ...mapActions("insumos", ["getPedidosComSaldo"]),
    headerPropsTabela() {
      return {
        sortByText: "Ordenar por",
      };
    },
    formatarData(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    isMobile() {
      return this.$mq == "sm";
    },
    pedidosFiltrados() {
      return this.pedidosComSaldo.filter((p) =>
        p.desc_pessoa.toLowerCase().includes(this.pesquisa.toLowerCase()) || 
        p.pedido.toString().includes(this.pesquisa.toLowerCase())
      );
    },
  },
  async mounted() {
    this.loading = true;
    await this.getPedidosComSaldo();
    this.loading = false;
  },
};
</script>

<style>
</style>